import accountPayable from "./accountPayable";
import jobRequests from "./jobRequests";
import propertyManagement from "./propertyManagement";
import userManagment from "./userManagment";
import settings from "./settings";
import home from "./home";
import report from "./report";
import dashboard from "./dashboard";
import bankReconciliation from "./bankReconciliation";
import userUsage from "./userUsage";
import recordAdjustmentRouter from "./recordAdjustment";
import payroll from "./payroll.js";
import accountReceivable from "./accountReceivable";

export default [
  accountPayable,
  jobRequests,
  propertyManagement,
  userManagment,
  settings,
  home,
  report,
  dashboard,
  userUsage,
  recordAdjustmentRouter,
  bankReconciliation,
  payroll,
  accountReceivable
];
